<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Icon / Dots">
<g id="Vector">
<path d="M9.33333 8.00002C9.33333 8.7364 8.73638 9.33335 8 9.33335C7.26362 9.33335 6.66667 8.7364 6.66667 8.00002C6.66667 7.26364 7.26362 6.66669 8 6.66669C8.73638 6.66669 9.33333 7.26364 9.33333 8.00002Z" fill="black" fill-opacity="0.5"/>
<path d="M14 8.00002C14 8.7364 13.403 9.33335 12.6667 9.33335C11.9303 9.33335 11.3333 8.7364 11.3333 8.00002C11.3333 7.26364 11.9303 6.66669 12.6667 6.66669C13.403 6.66669 14 7.26364 14 8.00002Z" fill="black" fill-opacity="0.5"/>
<path d="M4.66667 8.00002C4.66667 8.7364 4.06971 9.33335 3.33333 9.33335C2.59695 9.33335 2 8.7364 2 8.00002C2 7.26364 2.59695 6.66669 3.33333 6.66669C4.06971 6.66669 4.66667 7.26364 4.66667 8.00002Z" fill="black" fill-opacity="0.5"/>
</g>
</g>
</svg>
